import { useContext, useEffect, useState } from "react";
import Dropdown from "../../Genericos/Dropdown/Dropdown";
import { PortalContext } from "../../../context/Provider";
import "./ObraSocialStyle.css";
import { editarPaciente } from "../../../context/Actions/paciente/paciente";
import InputV1 from "../../Genericos/InputV1/InputV1";
import camelize from "../../../../global/utils/camelize";
import { regexNumero } from "../../../../global/utils/expresionesRegulares";
import { planObraSocial } from "../../../context/Actions/planObraSocial/planObraSocial";

const ObraSocial = () => {
  const {
    obraSocialState,
    planObraSocialState,
    planObraSocialDispatch,
    registroState,
    pacienteDispatch,
    pacienteState,
  } = useContext(PortalContext);

  const [obraSocialSeleccionada, setObraSocialSeleccionada] = useState([]);
  const [deshabilitaFormulario, setDesahabilitaFormulario] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [formularioPerfil, setformularioPerfil] = useState({
    nombre: pacienteState.paciente.datosActualizados.nombre,
    domicilio: camelize(pacienteState.paciente.datosActualizados.domicilio),
    telefono: pacienteState.paciente.datosActualizados.telefono,
    codigo_postal: pacienteState.paciente.datosActualizados.codigo_postal,
    fecha_nacimiento: pacienteState.paciente.datosActualizados.fecha_nacimiento,
    sexo: pacienteState.paciente.datosActualizados.sexo,
    email: pacienteState.paciente.datosActualizados.email,
    telefono_movil: pacienteState.paciente.datosActualizados.telefono_movil,
    idlocalidad: pacienteState.paciente.datosActualizados.idlocalidad,
    localidad_desc: camelize(
      pacienteState.paciente.datosActualizados.localidad
    ),
    cobertura: {
      OSInactiva: pacienteState.paciente.datosActualizados.cobertura.osInactiva,
      OSNoDaConsulta:
        pacienteState.paciente.datosActualizados.cobertura.osNoDaConsulta,
      OSNoDaEstudios:
        pacienteState.paciente.datosActualizados.cobertura.osNoDaEstudios,
      PlanInactivo:
        pacienteState.paciente.datosActualizados.cobertura.planInactivo,
      idCobertura:
        pacienteState.paciente.datosActualizados.cobertura.idCobertura,
      idCoberturaPlan:
        pacienteState.paciente.datosActualizados.cobertura.idCoberturaPlan,
      cobertura: pacienteState.paciente.datosActualizados.cobertura.cobertura,
      plan: pacienteState.paciente.datosActualizados.cobertura.plan,
      afiliado: pacienteState.paciente.datosActualizados.cobertura.afiliado,
    },
  });
  const [planSeleccionado, setPlanSeleccionado] = useState(false);
  const [osSeleccionada, setOsSeleccionada] = useState(false);
  const [numAfiliado, setNumAfiliado] = useState(false);

  const cobertura = pacienteState.paciente.datosActualizados.cobertura;

  // --------------------- USE EFFECTS -----------------------
  useEffect(() => {
    // deshabilta el formulario
    setDesahabilitaFormulario(true);
  }, []);
  useEffect(() => {
    // carga el contexto con los datos nuevos
    if (pacienteState.paciente.editaPerfil.estado) {
      editarPaciente(formularioPerfil)(pacienteDispatch);
    }
    //eslint-disable-next-line
  }, [formularioPerfil]);
  useEffect(() => {
    // carga el estado local con los datos nuevos
    setformularioPerfil({
      ...formularioPerfil,
      cobertura: {
        ...formularioPerfil.cobertura,
        plan: planSeleccionado.id,
        cobertura: osSeleccionada.codigo,
        idCobertura: osSeleccionada.codigo,
        idCoberturaPlan: planSeleccionado.id,
        afiliado: numAfiliado,
      },
    });
    //eslint-disable-next-line
  }, [planSeleccionado, osSeleccionada, numAfiliado]);

  useEffect(() => {
    // Permite editar si no está el flag
    let estadoPacienteEdit = pacienteState.paciente.editaPerfil.estado;
    let editarOS = pacienteState.paciente.datosActualizados.cambiarObraSocial;

    if (estadoPacienteEdit && editarOS) {
      setIsEditable(pacienteState.paciente.editaPerfil.estado);
    } else {
      setIsEditable(false);
    }
  }, [pacienteState.paciente.editaPerfil.estado]);
  // // --------------------- USE EFFECTS -----------------------

  // ------------------- FUNCIONES ---------------------
  const changePlanObraSocial = (e) => {
    // cambia el plan
    // {id, descripcion} = e
    const idPlan = e.id;
    if (idPlan) {
      setPlanSeleccionado(e);
    } else {
      setPlanSeleccionado(false);
    }
  };
  const onNroAfiliadoChange = (e) => {
    //cambia el nro afiliado
    const nroAfiliado = e.target.value;
    if (nroAfiliado) {
      setNumAfiliado(nroAfiliado);
    } else {
      setNumAfiliado(false);
    }
  };

  const changeObraSocial = (e) => {
    // cambia la OS
    // {codigo, nombre, mutual} = e

    if (e?.codigo) {
      planObraSocial(e.codigo)(planObraSocialDispatch);
      setOsSeleccionada(e);
    } else {
      setOsSeleccionada(false);
    }
  };
  const preventKeyTexto = (e) => {
    if (!regexNumero.test(e.key)) {
      e.preventDefault();
    }
  };

  // ------------------- FUNCIONES ---------------------

  return (
    <div className="ptur-perfil-obrasocial-box">
      <div className="ptur-perfil-obrasocial-col1-fila1">
        {isEditable ? (
          <Dropdown
            headerStr="Obra Social"
            datos={obraSocialState.obraSocial.data}
            onChange={changeObraSocial}
            campoCodigo="codigo"
            descripcion="nombre"
            placeholder="Seleccioná una obra social"
            desactivado={!pacienteState.paciente.editaPerfil.estado}
            valor={osSeleccionada.codigo}
            campoDescripcion={"nombre"}
            name="txtObraSocial"
            errorStr="La Obra Social es requerida"
            checkError={registroState.registro.listError.obra_social}
            isRequired={true}
            origen={"OBRA_SOCIAL"}
          />
        ) : (
          <InputV1
            inputType="text"
            headerStr="Obra Social"
            deshabilitaFormulario={true}
            desactivado={true}
            value={cobertura.cobertura}
          />
        )}
      </div>
      <div className="ptur-perfil-obrasocial-col1-fila2">
        {obraSocialSeleccionada?.codigo !== "PART" &&
          (isEditable ? (
            <Dropdown
              headerStr="Plan"
              datos={planObraSocialState.planObraSocial.data}
              onChange={changePlanObraSocial}
              campoCodigo="id"
              descripcion="descripcion"
              placeholder="Seleccioná un plan"
              desactivado={!pacienteState.paciente.editaPerfil.estado}
              name="txtPlan"
              errorStr="El Plan es requerido"
              valor={planSeleccionado.id}
              // isRequired={true}
              // checkError={registroState.registro.listError.plan_obra_social}
              // origen={"PLAN"}
            />
          ) : (
            <InputV1
              inputType="text"
              headerStr="Plan"
              deshabilitaFormulario={deshabilitaFormulario}
              desactivado={deshabilitaFormulario}
              value={cobertura.plan}
            />
          ))}
      </div>

      <div className="ptur-perfil-obrasocial-col1-fila3">
        {obraSocialSeleccionada?.codigo !== "PART" &&
          (isEditable ? (
            <InputV1
              inputType="text"
              name="txtAfiliado"
              headerStr="Número de afiliado"
              placeholderText="0020808"
              onChange={onNroAfiliadoChange}
              desactivado={!pacienteState.paciente.editaPerfil.estado}
              value={!numAfiliado ? "" : numAfiliado}
              errorStr="Ingresá un Numero de afiliado"
              className="rb16m"
              onKeyPress={preventKeyTexto}
              maxLength="25"
              checkError={registroState.registro.listError.nro_afiliado}
              isRequired={true}
            />
          ) : (
            <InputV1
              headerStr="Número de afiliado"
              value={cobertura.afiliado}
              className="rb16m"
              deshabilitaFormulario={deshabilitaFormulario}
            />
          ))}
      </div>
    </div>
  );
};
export default ObraSocial;
